<app-company-properties
  [company]="contractForm.company?.value"
  [displayedProperties]="companyDisplayedProperties"
></app-company-properties>
<div>
  <div tiimeLargeProperty>Contact :</div>
  <app-user-select
    [control]="contractForm.contact"
    [selectData]="users()"
    [small]="false"
    [errorMessage]="contractForm.contactErrorMessage"
    label=""
    (create)="openCreateUserDialog()"
    [allowCreateOption]="true"
    createOptionLabel="Ajouter un contact"
  ></app-user-select>
  @if (contractForm.contact.value; as contact) {
    <div class="phone-property" tiimeIconProperty>
      <mat-icon svgIcon="icon-phone"></mat-icon>
      <span class="italic ellipsis" tiimeFallbackText>
        {{ contact?.phone | phone }}
      </span>
    </div>
    <div tiimeIconProperty>
      <mat-icon svgIcon="icon-mail"></mat-icon>
      <span class="italic ellipsis" [tiimeTooltip]="contact?.email" tiimeFallbackText>
        {{ contact?.email }}
      </span>
    </div>
    <app-address-property
      tiimeIconProperty
      [street]="contact?.mailingStreet"
      [postalCode]="contact?.mailingPostalCode"
      [city]="contact?.mailingCity"
    ></app-address-property>
  }
</div>
<app-company-permanent-note-properties
  [permanentNote]="
    (contractForm.company?.value?.commentaries | commentariesGroupByType: companyPermanentNoteType)?.content
  "
></app-company-permanent-note-properties>
